/**
 * Wire-mapping for the governance role-definition registry (OIDCPAM Gate-6
 * Phase 6a — GovernanceRoleRegistry.tsx).
 *
 * `AdminListRoleDefsResp.items` is typed `Array<Record<string, unknown>>` in
 * the generated client — an opaque/untyped response, same pattern as
 * governanceDualAuthMapping.ts / governanceRolesMapping.ts. The backend
 * struct (pam_admin_role_registry.go#AdminRole) is `{ Name string
 * \`json:"name"\`, Description string \`json:"description,omitempty"\`,
 * Permissions []Permission \`json:"permissions"\`, Builtin bool
 * \`json:"builtin"\`, TenantID string \`json:"tenant_id"\`, ... }`.
 *
 * NOT A LATENT BUG here (unlike GovernanceRoles.tsx): `name`, `description`,
 * `permissions`, and `builtin` are all single-word JSON keys with no
 * snake_case/camelCase difference, so the pre-migration page's
 * `(data.items ?? []) as unknown as AdminRoleDef[]` cast happened to render
 * correctly at runtime — the fields this page actually reads
 * (rd.name/description/permissions/builtin) are case-invariant. Still
 * replaced with an explicit field-by-field mapping (rather than a blind
 * `as unknown as` cast) per the Gate-6 wire-mapping discipline, so a future
 * codegen/backend field rename fails typecheck instead of silently
 * regressing.
 */
import type {
  RoleDef as IamRoleDef,
} from '@devnw/cyber-iam/iam/types'

/** The real (camelCase-after-fromWire, but case-invariant) runtime shape of
 *  one AdminListRoleDefsResp item. */
export interface WireRoleDef {
  name: string
  description?: string
  permissions?: string[]
  builtin: boolean
}

export function toIamRoleDef(w: WireRoleDef): IamRoleDef {
  return {
    name: w.name,
    description: w.description,
    permissions: w.permissions ?? [],
    builtin: w.builtin,
  }
}
